import Image from "next/image";
import Link from "next/link";
import { ComponentProps, ReactNode } from "react";

import Card from "@/components/common/Card";
import { cn } from "@/utils/cn";

interface InterviewProps {
  href: string;
  image: ComponentProps<typeof Image>;
  title: string | ReactNode;
  content: string | ReactNode;
  onClick?: () => void;
}

function Interview({ image, title, content, ...props }: InterviewProps) {
  return (
    <Card as={Link} {...props}>
      <div className="relative aspect-video w-full">
        <Image className={cn("object-cover", image.className)} fill {...image} alt={image.alt || "카드 이미지"} />
      </div>
      <div className="px-4 pb-6 pt-4">
        <div className="mb-3 text-24 font-semibold">{title}</div>
        <div className="text-18 text-gray">{content}</div>
      </div>
    </Card>
  );
}

export default Interview;
